import styled from "styled-components";
import breakpoints from "../utils/breakpoints";
import coverImage from "../images/banner.svg";

const CoverCard = styled.div`
    background: url(${coverImage});
    width: 1085.15px;
    /* width: 58%; */
    height: 244.7px;
    border-radius: 5px;
    margin: 0 auto;
    background-position: center;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 1;


    @media only screen and ${breakpoints.device.md}{
      margin: 0 auto;
      width: 500px; 
      height: 150px;
    }

    @media only screen and ${breakpoints.device.sm}{
      margin: 0 auto;
      width: 300px;
      height: 100px;
    }
    
    @media only screen and ${breakpoints.device.lg}{
      margin: 0 auto;
      width: 1085.15px;
      height: 244.7px;
    }

   
`;

const Cover = ({}) => {
  return <CoverCard></CoverCard>;
};

export default Cover;
